import TweenMax from 'gsap/TweenMax';

export default function DiveDown(container, canvas, duration, beforeAnimation) {
  const {
    left: containerLeft,
    height: containerHeight,
  } = container.getBoundingClientRect();
  const {
    left: canvasLeft,
    height: canvasHeight,
  } = canvas.getBoundingClientRect();
  const initialX = -(containerLeft - canvasLeft);

  beforeAnimation(initialX, 0);

  TweenMax.to(container, 0.1, {
    opacity: 1,
    onComplete: () => {
      TweenMax.to(container, duration - 0.1, {
        y: (60 / 100) * canvasHeight - containerHeight,
      });
    },
  });
}
